import { render, staticRenderFns } from "./OrderView.vue?vue&type=template&id=084040e4&scoped=true&"
import script from "./OrderView.vue?vue&type=script&lang=js&"
export * from "./OrderView.vue?vue&type=script&lang=js&"
import style0 from "./OrderView.vue?vue&type=style&index=0&lang=css&"
import style1 from "./OrderView.vue?vue&type=style&index=1&id=084040e4&scoped=true&lang=css&"
import style2 from "./OrderView.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084040e4",
  null
  
)

component.options.__file = "OrderView.vue"
export default component.exports